import React from "react"
import { Link } from "react-router-dom"
import { PlusCircle } from "lucide-react"
import { STUDENT_PRACTICE_PAPERS_CREATE_PATH } from "./config/studentNavItems"
import { useGuardLinkClick } from "./unsavedChangesGate"
import "./NewPracticePaperLink.style.scss"

const NewPracticePaperLink = () => {
  const onClick = useGuardLinkClick(STUDENT_PRACTICE_PAPERS_CREATE_PATH)

  return (
    <Link
      to={STUDENT_PRACTICE_PAPERS_CREATE_PATH}
      className="student-new-paper-link"
      onClick={onClick}
    >
      <PlusCircle className="student-new-paper-link__icon" />
      New Practice Paper
    </Link>
  )
}

export default NewPracticePaperLink
